/**
 * Intercompany transaction types — aligned with Oracle/SAP-style enterprise systems.
 * Each type is clear about direction (receivable vs payable, sale vs purchase).
 */
export const ICP_TRANSACTION_TYPES: { value: string; label: string }[] = [
  { value: 'sale', label: 'Sale of Goods' },
  { value: 'purchase', label: 'Purchase of Goods' },
  { value: 'service', label: 'Service Fee' },
  { value: 'loan_receivable', label: 'Loan Receivable' },
  { value: 'loan_payable', label: 'Loan Payable' },
  { value: 'interest_receivable', label: 'Interest Receivable' },
  { value: 'interest_payable', label: 'Interest Payable' },
  { value: 'dividend', label: 'Dividend' },
  { value: 'management_fee', label: 'Management Fee' },
  { value: 'royalty', label: 'Royalty / License' },
  { value: 'rent', label: 'Rent' },
  { value: 'recharge', label: 'Cost Recharge' },
  { value: 'other', label: 'Other' },
  // Legacy (for backward compatibility with existing data)
  { value: 'trade', label: 'Trade' },
  { value: 'loan', label: 'Loan' },
  { value: 'interest', label: 'Interest' },
];

const LABEL_MAP: Record<string, string> = Object.fromEntries(
  ICP_TRANSACTION_TYPES.map((t) => [t.value, t.label])
);

export function getTransactionTypeLabel(value: string): string {
  return LABEL_MAP[value] ?? value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
